import { render, staticRenderFns } from "./campaigns-base-form.vue?vue&type=template&id=447a69c2&"
import script from "./campaigns-base-form.vue?vue&type=script&lang=js&"
export * from "./campaigns-base-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports